<div class="map-features page">
  <div class="title">Waterway & Fishing Map Features</div>
  <div class="description">
    Below is a list of a features that make Fishidy one of the most <br />
    popular social communities for people who love to fish.
  </div>
  <div class="content">
    <div class="box" *ngFor="let item of landingData.mapFeatures">
      <div class="box-icon">
        <mat-icon svgIcon="{{ item.icon }}" mat-list-icon></mat-icon>
      </div>
      <div class="box-title">{{ item.title }}</div>
      <div class="box-description">{{ item.description }}</div>
    </div>
  </div>
</div>
